"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListContainer = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classNames = require("classnames");
var recompose_1 = require("recompose");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var memoize = require("fast-memoize");
var ColumnFilter_1 = require("components/ColumnFilter");
var react_router_dom_1 = require("react-router-dom");
var sok_ui_1 = require("@caddigital/sok-ui");
var sokositeActions = require("@caddigital/sok-reducers/lib/actions/sokosite/list");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var translate_1 = require("utils/translate");
var Types = require("types");
var List_1 = require("@caddigital/sok-ui/lib/components/List");
var viewport_1 = require("reducers/viewport");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var text_1 = require("utils/text");
var search_1 = require("utils/search");
var NotFoundPlaceHolder_1 = require("components/NotFoundPlaceHolder");
var SortButton = sok_ui_1.Table.SortButton;
var headers = [
    'id',
    'name',
    'form_type',
    'entries',
    'waiting_for_signatures',
    'ready'
];
var mapStateToProps = function (state, ownProps) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        list: ownProps.currentProject
            ? state.sokosite.projectList
            : state.sokosite.list,
        isMobile: (0, viewport_1.isMobile)(state.viewport),
        selectedLanguage: selectedLanguage,
        user: state.auth.current.user
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (project) {
        return dispatch(sokositeActions.fetchRequest(project ? project.id : undefined));
    },
    setPaginationOptions: function (offset, limit, project) {
        return dispatch(sokositeActions.setPaginationOptions(offset, limit, project ? project.id : undefined));
    },
    setColumnFilter: function (field, value, project) {
        return dispatch(sokositeActions.setColumnFilter(field, value, project ? project.id : undefined));
    },
    setOrderBy: function (orderBy, order, project) {
        return dispatch(sokositeActions.setOrderBy(orderBy, order, project ? project.id : undefined));
    },
    toggleBookmark: function (x, status, project) {
        return dispatch(sokositeActions.bookmarkRequest(x, status, project ? project.id : undefined));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
function getFilteredData(list, seachString, filters) {
    var keys = Object.keys(filters);
    if (keys.length === 0) {
        if (seachString.length > 0) {
            return list.filter(function (item) {
                return item.name.toLowerCase().includes(seachString.toLowerCase());
            });
        }
        return list;
    }
    var filtered = list.reduce(function (result, item) {
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = item[key];
            if (key === 'name' &&
                (item['site_number'] !== undefined || item['site_number'] !== '')) {
                value += ' ' + item['site_number'];
            }
            var searchValue = filters[key];
            if (searchValue &&
                value !== undefined &&
                value !== null &&
                value.toString().toLowerCase().indexOf(searchValue.toLowerCase()) === -1) {
                return result;
            }
        }
        if (item.name.toString().includes(seachString)) {
            result.push(item);
        }
        return result;
    }, []);
    return filtered;
}
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('total', 'setTotal', 0), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.fetch(this.props.currentProject);
    },
    componentDidUpdate: function (prevProps) {
        var items = this.props.list.list;
        if (this.props.list.searchString !== prevProps.list.searchString ||
            this.props.list.orderByOptions !== prevProps.list.orderByOptions ||
            this.props.list.filterOptions !== prevProps.list.filterOptions ||
            this.props.list.offset !== prevProps.list.offset ||
            this.props.list.limit !== prevProps.list.limit ||
            (prevProps.list.list.length === 0 && this.props.list.list.length) ||
            this.props.list.list !== prevProps.list.list ||
            (prevProps.list.status !== 'FETCHED' &&
                this.props.list.status === 'FETCHED')) {
            var orderBy_1 = this.props.list.orderByOptions.orderBy;
            var order_1 = this.props.list.orderByOptions.order === 'asc' ? 1 : -1;
            var list = this.props.list;
            var data = getFilteredData(list.list, this.props.list.searchString, this.props.list.filterOptions).sort(function (a, b) {
                switch (orderBy_1) {
                    case 'form_type':
                    case 'name':
                        return a[orderBy_1].localeCompare(b[orderBy_1]) * order_1;
                    case 'id':
                    case 'entries':
                    case 'waiting_for_signatures':
                    case 'ready':
                        return (a[orderBy_1] < b[orderBy_1] ? -1 : 1) * order_1;
                    default:
                        return 0;
                }
            });
            items = data.slice(Math.max(0, Math.min(data.length, list.offset)), Math.min(list.offset + list.limit, data.length));
            this.props.setTotal(data.length);
            this.props.setItems(items);
        }
        if (this.props.list.list !== prevProps.list.list ||
            this.props.isMobile !== prevProps.isMobile) {
            var contentWidth_1 = 0;
            var columns_1 = this.props.list.list.reduce(function (p, item) {
                Object.keys(item).forEach(function (c) {
                    if (!headers.includes(c))
                        return p;
                    var dataKey = '__' + c.replace(/-/g, '');
                    var text = (function (v, c) {
                        if (c === 'entries' || c === 'ready') {
                            return v.toString();
                        }
                        return v;
                    })(((c === 'name'
                        ? item[c] +
                            (item['site_number'] ? ' ' + item['site_number'] : '')
                        : item[c]) || '').toString(), c);
                    var length = (0, text_1.calculateStringLength)(text);
                    var prevValue = p[dataKey];
                    if (prevValue && prevValue.length < length) {
                        prevValue.text = text;
                        prevValue.length = length;
                    }
                    else if (!prevValue) {
                        p[dataKey] = {
                            text: text,
                            length: length
                        };
                    }
                });
                return p;
            }, {});
            var shownHeaders_1 = headers;
            shownHeaders_1.forEach(function (x) {
                if (!shownHeaders_1.includes(x)) {
                    return;
                }
                var dataKey = '__' + x.replace(/-/g, '');
                var text = (0, translation_1.getLocalization)("sokositeView/column/".concat(x)).toString();
                var length = (0, text_1.calculateStringLength)(text) + 42;
                var prevValue = columns_1[dataKey];
                if (prevValue && prevValue.length < length) {
                    prevValue.text = text;
                    prevValue.length = length;
                }
                else if (!prevValue) {
                    columns_1[dataKey] = {
                        text: text,
                        length: length
                    };
                }
            });
            var lengths_1 = Object.keys(columns_1).reduce(function (prev, x) {
                prev[x] = columns_1[x].length;
                return prev;
            }, {});
            // Override styles for dynamic classes
            var style = document.getElementById('SokoSiteFormsListCSS');
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = 'SokoSiteFormsListCSS';
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            contentWidth_1 += 2 * 42;
            Object.keys(lengths_1).forEach(function (className, i) {
                var colwidth = Math.max(8, 4 + lengths_1[className] + 26); // convert to rem
                contentWidth_1 += colwidth;
                sheet_1.insertRule(".".concat(className) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            this.props.setContentWidth(contentWidth_1);
        }
    },
    componentWillUnmount: function () {
        var _this = this;
        headers.forEach(function (header) {
            _this.props.setColumnFilter(header, undefined, _this.props.currentProject);
        });
    }
}), recompose_1.pure);
function getColumn(column, value) {
    return (React.createElement("div", { className: classNames("row__column dynamic __".concat(column), column === 'name' && 'expand'), "data-key": "__".concat(column) }, value));
}
var getOptions = function () {
    return [
        {
            key: 'TRMeterForm',
            value: (0, translation_1.getLocalization)('trmeter')
        },
        {
            key: 'MVRMeterForm',
            value: (0, translation_1.getLocalization)('mvrmeter')
        },
        {
            key: 'WorksiteDiaryForm',
            value: (0, translation_1.getLocalization)('worksitediary')
        }
    ];
};
function getHeaderColumn(props, name, identifier) {
    var order = props.list.orderByOptions.orderBy === identifier &&
        props.list.orderByOptions.order === 'asc'
        ? 'desc'
        : 'asc';
    var enabled = true;
    var dataKey = '__' + identifier;
    return (React.createElement("div", { key: identifier, "data-key": dataKey, "data-length": name.length, className: classNames('row__column dynamic sokosite-list-row-column', dataKey) },
        React.createElement("div", { onClick: function () {
                props.setOrderBy(identifier, order, props.currentProject);
                var params = __assign(__assign({}, props.queryParams), { order: order, orderBy: identifier });
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } }, (0, translation_1.getLocalization)("sokositeView/column/".concat(name))),
        React.createElement(SortButton, { className: "d-none d-desktop-table-cell filter", order: props.list.orderByOptions.orderBy === identifier
                ? props.list.orderByOptions.order.toLowerCase()
                : null, disabled: !enabled, onChange: function () {
                props.setOrderBy(identifier, order, props.currentProject);
                var params = __assign(__assign({}, props.queryParams), { order: order, orderBy: identifier });
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } }),
        React.createElement(ColumnFilter_1.ColumnFilter, { className: props.list.filterOptions && props.list.filterOptions[identifier]
                ? 'active filter'
                : '' + ' filter', columnIdentifier: identifier, textInputValue: props.list.filterOptions && props.list.filterOptions[identifier]
                ? props.list.filterOptions[identifier] || ''
                : '', inputType: identifier === 'entries' ||
                identifier === 'waiting_for_signatures' ||
                identifier === 'ready'
                ? 'number'
                : identifier === 'form_type'
                    ? 'radiobutton'
                    : 'text', options: getOptions(), setColumnFilterString: function (field, value) {
                props.setColumnFilter(field, value, props.currentProject);
                var params = __assign({}, props.queryParams);
                params[field] = value;
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            }, clearColumnFilter: function (field) {
                props.setColumnFilter(field, undefined, props.currentProject);
                var params = __assign({}, props.queryParams);
                params[field] = undefined;
                props.updateUrl(props.pathname + (0, search_1.getQueryParams)(params));
            } })));
}
var enhanceHeader = (0, recompose_1.compose)((0, recompose_1.shouldUpdate)(function (nextProps, props) {
    return nextProps.isMobile !== props.isMobile ||
        (0, List_1.shallowDiffers)(nextProps.style, props.style) ||
        (0, List_1.shallowDiffers)(nextProps.list.orderByOptions, props.list.orderByOptions) ||
        (0, List_1.shallowDiffers)(props.list.filterOptions, nextProps.list.filterOptions);
}));
var Header = enhanceHeader(function (props) {
    return (React.createElement("div", { className: 'header row', style: props.style },
        React.createElement("div", { className: "row__column first narrow icon" }),
        getHeaderColumn(props, 'id', 'id'),
        getHeaderColumn(props, 'name', 'name'),
        headers
            .filter(function (x) { return x !== 'id' && x !== 'name'; })
            .map(function (header) { return getHeaderColumn(props, header, header); }),
        React.createElement("div", { className: "row__column narrow" })));
});
var createRowData = memoize(function (toggleBookmark, style, isMobile, user, items, selectedLanguage, currentProject) { return ({
    style: style,
    isMobile: isMobile,
    user: user,
    items: items,
    currentProject: currentProject,
    toggleBookmark: toggleBookmark,
    selectedLanguage: selectedLanguage
}); });
var ListRow = React.memo(function (_a) {
    var index = _a.index, data = _a.data, className = _a.className, style = _a.style;
    var isMobile = data.isMobile, items = data.items, toggleBookmark = data.toggleBookmark, currentProject = data.currentProject, selectedLanguage = data.selectedLanguage;
    var row = items[index];
    var formType = function (row) {
        switch (row.form_type) {
            case 'TRMeterForm':
                return 'trmvrmeter';
            case 'MVRMeterForm':
                return 'trmvrmeter';
            case 'WorksiteDiaryForm':
                return 'worksitediary';
            default:
                return '';
        }
    };
    var formUUID = function (row) {
        switch (row.form_type) {
            case 'TRMeterForm':
                return row.diary_uuid;
            case 'MVRMeterForm':
                return row.diary_uuid;
            default:
            case 'WorksiteDiaryForm':
                return row.diary_uuid;
        }
    };
    return (React.createElement("div", { className: classNames('row'), style: style },
        React.createElement("div", { className: "row__column narrow" }),
        React.createElement("div", { className: 'row__column mobile' },
            React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(currentProject.id, "/sokosite/").concat(formType(row), "/").concat(formUUID(row)) }, getColumn('id', row.id))),
        React.createElement("div", { className: 'row__column dynamic mobile __name expand' },
            React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(currentProject.id, "/sokosite/").concat(formType(row), "/").concat(formUUID(row)) },
                React.createElement("div", null,
                    row.name,
                    row.site_number ? " / ".concat(row.site_number) : ''))),
        getColumn('form_type', row.form_type === 'WorksiteDiaryForm'
            ? (0, translation_1.getLocalization)('worksitediary')
            : row.form_type === 'TRMeterForm'
                ? (0, translation_1.getLocalization)('trmeter')
                : (0, translation_1.getLocalization)('mvrmeter')),
        getColumn('entries', row.entries),
        getColumn('waiting_for_signatures', row.waiting_for_signatures),
        getColumn('ready', row.ready),
        React.createElement("div", { className: "row__column narrow" })));
});
exports.ListContainer = enhance(function (props) {
    // memoize item props into props.data object
    var itemData = createRowData(props.toggleBookmark, {}, props.isMobile, props.user, props.items, props.selectedLanguage, props.currentProject);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'sokosite-list-view-list-container' },
            React.createElement("div", { className: 'sok-list-content sokosite-list-view-list ' +
                    props.list.status.toLowerCase() },
                props.list.status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: 'error', title: (0, translation_1.getLocalization)('generic/error') },
                    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () { return props.fetch(props.currentProject); } }))),
                props.list.status === 'FETCHING' && (React.createElement("div", { key: 'loading', className: 'loading' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                props.list.status === 'FETCHED' && props.items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(Header, __assign({}, props)), placeholder: React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { className: "no-sokosites", key: "no-sokosites", title: "diaryEntriesView/emptyList/title", message: "diaryEntriesView/emptyList/message" }) }, ListRow));
                })))),
        React.createElement(sok_ui_1.Pagination, { key: 'pagination', limit: props.list.limit, total: props.total, limitOptions: props.list.itemsPerPage, offset: props.list.offset, updatePageState: function (offset, limit) {
                props.setPaginationOptions(offset, limit, props.currentProject);
                props.updateUrl(props.pathname +
                    (0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { offset: offset, limit: limit })));
            } })));
});
